import React from "react"
import { Link } from "gatsby"
import * as styles from "./footer.module.scss"

// Import using query for optimization
import Logo from "../../images/logo-small.png"

import TwitterLogo from "../../images/svgs/x-twitter.inline.svg"
import YoutubeLogo from "../../images/svgs/youtube.inline.svg"
import LinkedinLogo from "../../images/svgs/linkedin.inline.svg"
import InstagramLogo from "../../images/svgs/instagram.inline.svg"

const Footer = () => {
    const year = new Date().getFullYear();

    return(
        <footer>
            <div className="container">
                <div className={styles.footer}>
                    <div className={styles.footer__top}>
                        <a href="tel:+4402045242660" title="Telephone +44 (0)20 4524 2660">
                            <img src={Logo} alt="Brandcast health logo" width="50" height="50" loading="lazy" />
                            <span>+44 (0)20 4524 2660</span>
                        </a>

                        <div className={styles.footer__social}>
                            <a className={styles.x} href="https://www.linkedin.com/company/brandcast-health" rel="noreferrer" aria-label="Visit Brandcast Health X page" title="Visit Brandcast Health X page" target="_blank">
                                <TwitterLogo />
                            </a>
                            <a href="https://www.linkedin.com/company/brandcast-health" rel="noreferrer" aria-label="Visit Brandcast Health LinkedIn page" title="Visit Brandcast Health LinkedIn page" target="_blank">
                                <LinkedinLogo />
                            </a>
                            <a href="https://www.instagram.com/brandcasthealth/?hl=en" rel="noreferrer" aria-label="Visit Brandcast Health Instagram page" title="Visit Brandcast Health Instagram page" target="_blank">
                                <InstagramLogo />
                            </a>
                            <a href="https://www.youtube.com/channel/UCpNd8mjbMDHB3y6YumY68lA" rel="noreferrer" aria-label="Visit Brandcast Health YouTube page" title="Visit Brandcast Health YouTube page" target="_blank">
                                <YoutubeLogo />
                            </a> 
                        </div>
                    </div>

                    <div className={styles.footer__bottom}>
                        <p><small>Copyright © {year} Brandcast Media Ltd</small></p>
                        
                        <div className={styles.footer__bottom__links}>
                            <Link to='/privacy-policy' aria-label="Privacy Policy" title="Privacy Policy"><small>Privacy Policy</small></Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer